module.exports = __webpack_public_path__ + "static/media/sprocket-web-black.42b270cf.svg";